// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import intvoppEntity from './entities/intvopp.json';
import intvoppMenu from '../pages/intvopp/menu.json';
import intvoppFullForm from '../pages/intvopp/forms/full.json';
import intvoppContextForm from '../pages/intvopp/forms/context.json';
import intvoppMiniForm from '../pages/intvopp/forms/mini.json';
import intvoppLookupForm from '../pages/intvopp/forms/lookup.json';
import intvoppTableView from '../pages/intvopp/views/table.json';
import intvoppStagesView from '../pages/intvopp/views/stages.json';
import intvoppCardsView from '../pages/intvopp/views/cards.json';
import intvoppInlineView from '../pages/intvopp/views/inline.json';
import intvoppBacklogView from '../pages/intvopp/views/backlog.json';
import intvoppSplitView from '../pages/intvopp/views/split.json';
import intvoppCalendarView from '../pages/intvopp/views/calendar.json';
import intvoppDashboardView from '../pages/intvopp/views/dashboard.json';

/** Тип запису «Опонент» зі сторінками пакета: меню, форми та подання з pages/intvopp/. */
export const intvoppDefinition: IRecordTypeDefinition = {
  ...intvoppEntity,
  views: assembleViewSet({
      table: intvoppTableView,
      stages: intvoppStagesView,
      cards: intvoppCardsView,
      inline: intvoppInlineView,
      backlog: intvoppBacklogView,
      split: intvoppSplitView,
      calendar: intvoppCalendarView,
      dashboard: intvoppDashboardView,
  }),
  form: intvoppFullForm,
  forms: { full: intvoppFullForm, context: intvoppContextForm, mini: intvoppMiniForm, lookup: intvoppLookupForm },
  menu: intvoppMenu,
} as IRecordTypeDefinition;
